import { WHERING_BASE_URL } from ".";
import wheringFetch from "../../helpers/fetch";

const route = "app/v1/beautify";
const baseUrl = WHERING_BASE_URL;

const beautifyApi = {
  getReviews: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page !== undefined) queryParams.append("page", params.page);
    if (params.limit !== undefined) queryParams.append("limit", params.limit);
    if (params.review_score !== undefined) queryParams.append("review_score", params.review_score);
    
    const queryString = queryParams.toString();
    const url = queryString ? `${route}/reviews?${queryString}` : `${route}/reviews`;
    
    return wheringFetch(baseUrl, url, "GET");
  },
};

export default beautifyApi;